// extracted by mini-css-extract-plugin
export var chip = "_4v-0";
export var filterDropdown = "_4v-5";
export var filterItem = "_4v-6";
export var icon = "_4v-1";
export var removeButton = "_4v-3";
export var removeIcon = "_4v-4";
export var separator = "_4v-2";